import { render } from "./ChooseBroker.vue?vue&type=template&id=0b8b393a"
import script from "./ChooseBroker.vue?vue&type=script&lang=js"
export * from "./ChooseBroker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__